export default __webpack_public_path__ + "static/media/1492509273_camera_ios7_ios_7.e4e6089e.png";